"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hex = hex;
function hex(s) {
    return s
        .split('')
        .map(c => c.charCodeAt(0).toString(16).padStart(2, '0'))
        .join('');
}
